(function () {
    'use strict';

    function typeFromId() {
        return function (value) {
            return Humanize.titleCase(value.split('/')[0]).slice(0, -1);
        };
    }

    angular.module('ecap.common').filter('typeFromId', typeFromId);
})();